export enum ModalName {
  LicenseType = 'AddOrUpdateLicenseTypeModal',
  LicenseTypeDetail = 'LicenseTypeDetailModal',
}
